import { ClientPanels, ClientTabs } from "slot-definitions"
import { Tab } from "@mui/material"

import { TabPanel } from "@mui/lab"
import { registerFeature } from "lib/features"
import { Feature, isEnabled } from "lib/@components/feature"
import { ClientStats } from "routes/settings/plugins/stats/components/client-stats"

export const FEATURE_FLAG_CLIENT_STATS = registerFeature({
    numericalId: 200,
    name: "Client Statistics",
    id: "client-statistics-all-users",
    description: `Client Statistics for admin users`,
    readyForBeta: false,
    readyForProduction: false,
})

ClientTabs.plug(
    <Tab if={() => isEnabled(FEATURE_FLAG_CLIENT_STATS)} label="Usage Stats" value="client-stats" priority={990} />
)

ClientPanels.plug(
    <TabPanel value="client-stats" demand="admin-usage">
        <Feature feature={FEATURE_FLAG_CLIENT_STATS} fallback={<>{FEATURE_FLAG_CLIENT_STATS} is not enabled.</>}>
            <ClientStats $lazy />
        </Feature>
    </TabPanel>
)
